module.exports = __webpack_public_path__ + "media/assets/images/hero-unit/confetti-59156c3c4b7afc75224ef9e978288c5b.png";